import request from '@/utils/request'

/**
* 消息查看API
*
* @author Jay Qing
* @since 2021/11/18
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = 'system/message/view'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_MINE_URL = `${BASE_URL}/page-mine`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: string | number) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
 * 查询未读消息的数量
 */
export function getUnreadMessages() {
  return request({
    url: `${BASE_URL}/unread-messages`,
    method: 'get'
  })
}
